import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=6fdd9d9a&scoped=true&"
var script = {}
import style0 from "./welfare.vue?vue&type=style&index=0&id=6fdd9d9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdd9d9a",
  null
  
)

export default component.exports